module.exports = __webpack_public_path__ + "img/13-download.7d46836b.png";